export { default as UserAdd } from './user-add';
export { default as UserGroup } from './user-group';
export { default as User } from './user';



// WEBPACK FOOTER //
// ./src/icon/svgs/user/index.js